"use strict";

exports.__esModule = true;

var _assign = require("../core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};


/*****************
 ** WEBPACK FOOTER
 ** ../~/babel-runtime/helpers/extends.js
 ** module id = 273
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/babel-runtime/helpers/extends.js
 ** module id = 273
 ** module chunks = 1
 **/